import { createSlice } from '@reduxjs/toolkit';
import DebugService from '../services/DebugService';

const initialState = {
  globalKey: undefined,
  flow: [],
}

// facon tuto
// -----------

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    generateGlobalKey: (state, _action) => {
      state.globalKey = (new Date()).getTime() + '';
      if (DebugService.getInstance().enabled) console.log('_AppStore : generateGlobalKey',{globalKey:state.globalKey});
    },
    addFlowItem: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.flow.push(action.payload);
      if (DebugService.getInstance().enabled) console.log('_AppStore : addFlowItem',{steps:state.steps});
    },
  },
});

// Action creators are generated for each case reducer function
export const { generateGlobalKey,addFlowItem } = appSlice.actions;
export default appSlice.reducer;

// facon JDIAZ
// -----------

// const ACTIONS = {
//   ADD_STEP: 'ADD_STEP',
// };

// const DISPATCH = {
//   addStep: step => {
//     return {type: ACTIONS.ADD_STEP, step};
//   },
// };

// const addStep = (state, action) => {
//   state.steps.push(action.steps);
// };

// const reducer = (
//   state = JSON.parse(JSON.stringify(initialState)),
//   action = {type: ''},
// ) => {
//   switch (action.type) {
//     case ACTIONS.ADD_STEP:
//       addStep(state, action);
//       break;
//     default:
//       return state;
//   }
//   return {...state};
// };

// export default reducer;
// export {ACTIONS, DISPATCH};